/**
 * As this file is reused in several other files, try to keep it lean and small.
 * Importing other npm packages here could lead to needlessly increasing the client bundle size, or end up in a server-only function that don't need it.
 */

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}

// IMPORTANT: In Next.js, webpack only replaces direct property access like process.env.NEXT_PUBLIC_*
// We must access process.env.NEXT_PUBLIC_* directly (not through a variable or function) for webpack to statically analyze and replace
// Access each variable directly in the exports so webpack can replace them at build time

export const dataset = assertValue(
  // Direct access to process.env.NEXT_PUBLIC_SANITY_DATASET - webpack will replace this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof process !== "undefined" && (process as any).env?.NEXT_PUBLIC_SANITY_DATASET,
  "Missing environment variable: NEXT_PUBLIC_SANITY_DATASET",
);

export const projectId = assertValue(
  // Direct access to process.env.NEXT_PUBLIC_SANITY_PROJECT_ID - webpack will replace this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof process !== "undefined" && (process as any).env?.NEXT_PUBLIC_SANITY_PROJECT_ID,
  "Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID",
);

/**
 * see https://www.sanity.io/docs/api-versioning for how versioning works
 */
export const apiVersion =
  // Direct access to process.env.NEXT_PUBLIC_SANITY_API_VERSION - webpack will replace this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (typeof process !== "undefined" && (process as any).env?.NEXT_PUBLIC_SANITY_API_VERSION) ||
  "2025-10-02";

/**
 * Used to configure edit intent links, for Presentation Mode.
 * For standalone studio, this should point to the studio domain (e.g., https://studio.tzero.com).
 * For Next.js app, this can be set via NEXT_PUBLIC_STUDIO_URL env var.
 */
export const studioUrl =
  // Direct access to process.env.NEXT_PUBLIC_STUDIO_URL - webpack will replace this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (typeof process !== "undefined" && (process as any).env?.NEXT_PUBLIC_STUDIO_URL) ||
  "https://studio.tzero.com";
